import {
    getDataWithParams,
    postData,
    patchData,
    destroyData
} from '@/store/api/method'

const request = {
    page: 1,
    show: 10,
    sortBy: "order",
    sorting: "DESC",
    search: null
} 
const initialState = () => ({
    message: 'Jaringan Bermasalah',
    status: 0,
    data: {last_page: 0,data: [], total: 0},
    request:{
        ...request
    },
})
const state = initialState
const getters = {
    getRequest: state => state.request,
    getMessage: state => state.message,
    getStatus: state => state.status,
    getData: state => state.data
}

const actions = {
    setRequest({commit}, value){
        commit("SET_REQUEST", value)
    },
    resetRequest({commit}){
        commit("SET_REQUEST", request)
    },
    async index({commit, state }, id) 
    {
        try {
            const url = `/yudisium-lecture-role/${id}`
            const response = await getDataWithParams(url,state.request);
            commit('SET_RESPONSE', response.data);
            commit('SET_DATA', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async store({commit }, data) 
    {
        try {
            const url = `/yudisium-lecture-role`
            const response = await postData(url,data);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async update({commit }, {data, id}) 
    {
        try {
            const url = `/yudisium-lecture-role/${id}`
            const response = await patchData(url,data);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async destroy({commit }, id) 
    {
        try {
            const url = `/yudisium-lecture-role/${id}`
            const response = await destroyData(url);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },
    
}

const mutations = {
    SET_FAILED(state) {
        state.message = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MESSAGE(state, err) {
        if(err.status == 400){
            state.message = err.data.msg
            state.status = err.data.status
        }else{
            state.message = 'Jaringan Bermasalah'
            state.status = 0
        }
    },
    SET_RESPONSE(state, response){
        state.message = response.msg
        state.status = response.status
    },
    SET_DATA(state, response){
        state.data = response.data
    },
    SET_REQUEST(state, value){
        state.request = value
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}